<template>
  <div>
    <a-menu
      :open-keys.sync="openKeys"
      :defaultSelectedKeys="['5-1']"
      :defaultOpenKeys="['5']"
      mode="inline"
      theme="dark"
      :inlineCollapsed="collapsed"
    >
      <a-menu-item key="1" @click="hrefSrc('1')">
        <a-icon type="home" />
        <span>返回主界面</span>
      </a-menu-item>
      <a-sub-menu key="4">
        <span slot="title">
          <a-icon type="profile" />
          <span>工单管理</span>
        </span>
        <a-menu-item key="4-1" @click="hrefSrc('4-1')">工单</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="5">
        <span slot="title">
          <a-icon type="line-chart" />
          <span>运营数据</span>
        </span>
        <a-menu-item key="5-1" @click="hrefSrc('5-1')">员工战报</a-menu-item>
        <a-menu-item key="5-2" @click="hrefSrc('5-2')">项目数据</a-menu-item>
        <!-- <a-menu-item key="5-3" @click="hrefSrc('5-3')">招聘成本</a-menu-item> -->
        <!-- <a-menu-item key="5-4" @click="hrefSrc('5-4')">人力成本</a-menu-item> -->
      </a-sub-menu>
      <a-sub-menu key="2">
        <span slot="title">
          <a-icon type="account-book" />
          <span>岗位薪资</span>
        </span>
        <a-menu-item key="2-6" @click="hrefSrc('2-6')">配置常用项</a-menu-item>
        <a-menu-item key="2-1" @click="hrefSrc('2-1')">盒马骑手</a-menu-item>
        <a-menu-item key="2-2" @click="hrefSrc('2-2')">美团BD</a-menu-item>
        <a-menu-item key="2-5" @click="hrefSrc('2-5')">美团大仓</a-menu-item>
        <a-menu-item key="2-3" @click="hrefSrc('2-3')">店员</a-menu-item>
        <a-menu-item key="2-4" @click="hrefSrc('2-4')">临时工</a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="3">
        <span slot="title">
          <a-icon type="smile" />
          <span>设置</span>
        </span>
        <a-menu-item key="3-1" @click="hrefSrc('3-1')"
          >门店/大仓/区域</a-menu-item
        >
        <a-menu-item key="3-2" @click="hrefSrc('3-2')">员工</a-menu-item>
        <a-menu-item key="3-3" @click="hrefSrc('3-3')">管理员</a-menu-item>
        <!-- <a-menu-item key="3-5" @click="hrefSrc('3-5')">配置结算价</a-menu-item> -->
        <!-- <a-menu-item key="3-6" @click="hrefSrc('3-6')"
          >配置招聘成本</a-menu-item
        > -->
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapsed: false,
      openKeys: ["1", "2", "3", "4", "5"]
    };
  },
  methods: {
    hrefSrc(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "home" });
          break;
        case "2-1":
          this.$router.push({ name: "ManpowerQSSettle" });
          break;
        case "2-2":
          this.$router.push({ name: "ManpowerBDSettle" });
          break;
        case "2-3":
          this.$router.push({ name: "manpowerDYSettle" });
          break;
        case "2-4":
          this.$router.push({ name: "manpowerJZSettle" });
          break;
        case "2-5":
          this.$router.push({ name: "manpowerDCSettle" });
          break;
        case "2-6":
          this.$router.push({ name: "manpowerSetOrder" });
          break;
        case "3-1":
          this.$router.push({ name: "manpowerShops" });
          break;
        case "3-2":
          this.$router.push({ name: "manpowerWorker" });
          break;
        case "3-3":
          this.$router.push({ name: "manpowerAdministrator" });
          break;
        case "3-5":
          this.$router.push({ name: "manpowerSetAccount" });
          break;
        case "3-6":
          this.$router.push({ name: "manpowerRecruitCostSet" });
          break;
        case "4-1":
          this.$router.push({ name: "manpowerWorkOrder" });
          break;
        case "5-1":
          this.$router.push({ name: "manpowerMonthSettlement" });
          break;
        case "5-2":
          this.$router.push({ name: "manpowerProSettlement" });
          break;
        case "5-3":
          this.$router.push({ name: "manpowerRecruitCostList" });
          break;
        case "5-4":
          this.$router.push({ name: "manpowerHumanCostList" });
          break;
      }
    }
  }
};
</script>
